import React, { Fragment } from "react";
import PropTypes from "prop-types";
import "./boxGrid.scss";

const BoxGrid = (props) => {
  const data = props.benchmark_data;

  let sharpe = data.filter(
    (e) => e["metric_name"].toLowerCase() === "sharpe ratio"
  );
  let sortino = data.filter(
    (e) => e["metric_name"].toLowerCase() === "sortino ratio"
  );
  let annualize = data.filter(
    (e) => e["metric_name"].toLowerCase() === "annualized alpha"
  );
  let beta = data.filter((e) => e["metric_name"].toLowerCase() === "beta");

  return (
    <Fragment>
      {data.length > 1 ? (
        <div className="parent_box">
          <div className="dot" />
          <div className="ratio_box">
            <div className="bb">
              {sharpe.length === 0 || sharpe[0]["fund"] === null ? (
                "-"
              ) : (
                <Fragment>
                  <div className="value_size">
                    {(
                      Math.round((sharpe[0]["fund"] * 1000) / 10) / 100
                    ).toFixed(2)}
                  </div>
                  <div>{sharpe[0]["metric_name"]}</div>
                </Fragment>
              )}
            </div>
            <div className="bb bl">
              {sortino.length === 0 || sortino[0]["fund"] === null ? (
                "-"
              ) : (
                <Fragment>
                  <div className="value_size">
                    {(
                      Math.round((sortino[0]["fund"] * 1000) / 10) / 100
                    ).toFixed(2)}
                  </div>
                  <div>{sortino[0]["metric_name"]}</div>
                </Fragment>
              )}
            </div>
          </div>
          <div className="ratio_box">
            <div className="br">
              {annualize.length === 0 || annualize[0]["fund"] === null ? (
                "-"
              ) : (
                <Fragment>
                  <div className="value_size">
                    {(
                      Math.round((annualize[0]["fund"] * 1000) / 10) / 100
                    ).toFixed(2)}
                  </div>
                  <div>{annualize[0]["metric_name"]}</div>
                  {/* <div>Annualized Alpha</div> */}
                </Fragment>
              )}
            </div>
            <div>
              {beta.length === 0 || beta[0]["fund"] === null ? (
                "-"
              ) : (
                <Fragment>
                  <div className="value_size">
                    {(Math.round((beta[0]["fund"] * 1000) / 10) / 100).toFixed(
                      2
                    )}
                  </div>
                  <div>{beta[0]["metric_name"]}</div>
                </Fragment>
              )}
            </div>
          </div>
        </div>
      ) : null}
    </Fragment>
  );
};

BoxGrid.propTypes = {
  benchmark_data: PropTypes.arrayOf(
    PropTypes.shape({
      metric_name: PropTypes.string.isRequired,
      fund: PropTypes.number.isRequired,
    })
  ),
};
export default BoxGrid;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/statistics/RiskStatistic/section2/boxGrid/boxGrid.jsx